<template>
    <div>
        <div :class="customTableClass" :style="customTableStyle">
            <div v-if="loading" style="color: #aaa;font-size: 14px;">
                数据加载中
            </div>
            <div v-else>
                <div style="display: flex;align-items: flex-start;">
                    <div style="width: 60px;" v-if="checkable && option.editable">
                        <checkbox :value="allitemChecked" @on-change="checkAllChanged"></checkbox>
                    </div>
                    <div style="width: 60px;" v-if="option.editable"></div>
                    <div v-if="!c.hide" v-for="(c,index) in columns" class="flex" :key="index" :style="'width: '+c.width+'px;color: #aaa;padding-right: 10px;'">
                        <div>
                            <div>{{c.title}}</div>
                            <div v-if="c.label" style="line-height: 1;font-size: 10px;">{{c.label}}</div>
                        </div>
                        <PageTooltip v-if="c.tip" :content="c.tip" :width="300" :name="''" :placement="'top-start'" />
                    </div>
                </div>
                <div style="display: flex;align-items: flex-start;" v-if="checkable && option.editable && newItems.filter(o=>{return o._checked})[0]">
                    <div style="width: 60px;margin-top: 10px;display: flex;align-items: center;">
                    </div>
                    <div v-if="option.editable && quickedit" style="width: 60px;margin-top: 10px;display: flex;align-items: center;">
                    </div>
                    <div style="display: flex;margin-top: 10px;align-items: center;">
                        <div :style="'width: '+columns[i].width+'px;padding-right:10px;'" v-for="(c,i) in columns" :key="i">
                            <div v-if="!c.batchset">--</div>
                            <div v-else>
                                <div v-if="c.type=='xieyi'">
                                    <Button type="primary" @click="columns[i].onclick(-1,batchitem)">批量选择协议</Button>
                                </div>
                                <div v-if="c.type=='button'">
                                    <Button type="primary" @click="columns[i].onclick(-1,batchitem)">批量设置</Button>
                                </div>
                                <div v-if="c.type=='wupin'">
                                </div>
                                <div v-else-if="c.type=='selection'">
                                    <div v-if="c.editable">
                                        <Select v-if="c.version==2||c.batchset" placeholder="批量设置" :value="batchitem[c.keyStr || (c.key+'Str')]" @on-change="dataChanged(batchitem,c,$event,'batch')" :style="'width: '+(c.width - 10)+'px;'">
                                            <Option v-for="(s,si) in c.selections(batchitem)" :key="si" :value="c.selectionvalue?c.selectionvalue(s):s[c.selectionKey]">
                                                {{c.selectionrender?c.selectionrender(batchitem,s):s[c.selectionKey]}}
                                            </Option>
                                        </Select>
                                        <select v-else placeholder="批量设置" class="wupin-select" v-model="batchitem[c.keyStr || (c.key+'Str')]" @change="dataChanged(batchitem,c,batchitem[c.keyStr || (c.key+'Str')],'batch')" :style="'width: '+(c.width - 20)+'px;'">
                                            <option class="wupin-option" v-for="(s,si) in c.selections(batchitem)" :key="si" :value="c.selectionvalue?c.selectionvalue(s):s[c.selectionKey]">
                                                {{c.selectionrender?c.selectionrender(batchitem,s):s[c.selectionKey]}}</span>
                                            </option>
                                        </select>
                                    </div>
                                    <div v-else>{{batchitem[c.keyStr || (c.key+'Str')]}}</div>
                                </div>
                                <div v-else-if="c.type=='danjia'">
                                    <div v-if="c.permission && !session.permission[c.permission]">--</div>
                                    <div v-else>
                                        <custom-input :value="batchitem[c.key]" :fix="c.fixAppend ? c.fixAppend(batchitem) : 6" :min="c.min" :max="c.max" placeholder="批量设置" @input="getInput($event, batchitem, c, 'batch')" :width="columns[i].width - 10" v-if="c.editable" :unit="c.append? c.append(batchitem) : ''"></custom-input>
                                        <div v-else-if="c.calculate">{{c.calculate(batchitem) | AmountDecimal(c.fixAppend ? c.fixAppend(batchitem) : 6)}}</div>
                                        <div v-else>{{batchitem[c.key] | AmountDecimal(c.fixAppend ? c.fixAppend(batchitem) : 6)}}</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type=='jine'">
                                    <div v-if="c.permission && !session.permission[c.permission]">--</div>
                                    <div v-else>
                                        <custom-input :value="batchitem[c.key]" :fix="2" :min="c.min" :max="c.max" placeholder="批量设置" @input="getInput($event, batchitem, c, 'batch')" :width="columns[i].width - 10" v-if="c.editable" :unit="c.append? c.append(batchitem) : ''"></custom-input>
                                        <div v-else-if="c.calculate">{{c.calculate(batchitem) | AmountDecimal(2)}}</div>
                                        <div v-else>{{batchitem[c.key] | AmountDecimal(2)}}</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type=='shuilv'">
                                    <div v-if="c.permission && !session.permission[c.permission]">--</div>
                                    <div v-else>
                                        <custom-input :value="batchitem[c.key]" :fix="4" :min="c.min" :max="c.max" placeholder="批量设置" @input="getInput($event, batchitem, c, 'batch')" :width="columns[i].width - 10" v-if="c.editable" :unit="c.append? c.append(batchitem) : ''"></custom-input>
                                        <div v-else-if="c.calculate">{{c.calculate(batchitem) | AmountDecimal(4)}}</div>
                                        <div v-else>{{batchitem[c.key] | AmountDecimal(4)}}</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type=='shuliang'">
                                    <div v-if="c.permission && !session.permission[c.permission]">--</div>
                                    <div v-else>
                                        <custom-input :value="batchitem[c.key]" :fix="6" :min="c.min" :max="c.max" placeholder="批量设置" @input="getInput($event, batchitem, c, 'batch')" :width="columns[i].width - 10" v-if="c.editable" :unit="c.append? c.append(batchitem) : ''"></custom-input>
                                        <div v-else-if="c.calculate">{{c.calculate(batchitem) | AmountDecimal(6)}}</div>
                                        <div v-else>{{batchitem[c.key] | AmountDecimal(6)}}</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type === 'text' || c.type === 'beizhu'">
                                    <div v-if="c.editable">
                                        <Input v-model="batchitem[c.key]" placeholder="批量设置" />
                                    </div>
                                    <div v-else>{{batchitem[c.key]}}</div>
                                </div>
                                <div v-else>
                                    <div>{{(batchitem[c.key] && c.subKey) ? batchitem[c.key][c.subKey] : batchitem[c.key]}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(item,index) in newItems" :key="index" style="display: flex;align-items: center;">
                    <div v-if="checkable && option.editable" style="width: 60px;margin-top: 10px;display: flex;align-items: center;">
                        <checkbox v-model="item._checked" @on-change="checkChanged"></checkbox>
                    </div>
                    <div v-if="option.editable && quickedit" style="width: 60px;margin-top: 10px;display: flex;align-items: center;">
                        <div v-if="item._readonly">
                            <Icon type="md-add" size="20" color="#ccc"></Icon>
                            <Icon type="md-remove" size="20" color="#ccc"></Icon>
                        </div>
                        <div v-else>
                            <Icon type="md-add" size="20" color="#20bf64" class="hover" @click="addItem(item,index)"></Icon>
                            <Icon type="md-remove" size="20" color="#20bf64" class="hover" @click="removeItem(item,index)"></Icon>
                        </div>
                    </div>
                    <div v-if="item.disabled">
                        <div style="font-weight: bold;word-wrap:break-word;" :title="item.name">{{item.name}} </div>
                        <div style="font-size: 11px;color: #aaa;line-height: 1;">{{item.code}} </div>
                        <div style="display: flex;line-height: 1;font-size: 11px;color: #aaa;">
                            <div v-if="item.guigexinghao">{{item.guigexinghao}}</div>
                            <div v-if="item.wupinpinpai">{{item.wupinpinpai}}</div>
                        </div>
                        <div style="font-size: 11px;color: red;line-height: 1;margin-top: 8px;" v-if="item.actived === false">已停用</div>
                        <div style="font-size: 11px;color: red;line-height: 1;margin-top: 8px;" v-if="item.weixiafa">未下发</div>
                        <div style="font-size: 11px;color: red;line-height: 1;margin-top: 8px;" v-if="item.error">{{item.error}}</div>
                        <slot name="disableText" />
                    </div>
                    <div v-else style="display: flex;margin-top: 10px;align-items: center;">
                        <div :style="'width: '+columns[i].width+'px;padding-right:10px;'" v-for="(c,i) in columns" :key="i">
                            <div v-if="c.vif && !c.vif(item)">--</div>
                            <div v-else>
                                <div v-if="c.type=='xieyi'" :title="item.name" :style="item.error?'color:red':''">
                                    <div v-if="item.xieyi">
                                        {{item.xieyi.name}}
                                        <div :style="`${item.error?'color:red;':'color: #aaa;'}font-size: 11px;line-height: 1;`">{{item.xieyi.code}} </div>
                                    </div>
                                    <div v-else>
                                        <Button type="primary" @click="columns[i].onclick(index,item)">选择协议</Button>
                                    </div>
                                </div>
                                <div v-if="c.type=='button'" :style="item.error?'color:red':''">
                                    <div v-if="c.editable">
                                        <div v-if="item[c.key] && c.html">
                                            <div @click="columns[i].onclick(index,item)">
                                                <div v-html="c.html(item,index)"></div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <Button type="primary" @click="columns[i].onclick(index,item)">{{c.name}}</Button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-if="item[c.key] && c.html">
                                            <div v-html="c.html(item,index)"></div>
                                        </div>
                                        <div v-else>-</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type=='wupin'" :title="item.name" :style="item.error?'color:red':''">
                                    <div style="font-weight: bold;word-wrap:break-word;" :title="item.name">{{item.name}} </div>
                                    <div :style="`${item.error?'color:red;':'color: #aaa;'}font-size: 11px;line-height: 1;`">{{item.code}} </div>
                                    <div :style="`${item.error?'color:red;':'color: #aaa;'}display: flex;line-height: 1;font-size: 11px;`">
                                        <div v-if="item.guigexinghao">{{item.guigexinghao}}</div>
                                        <div v-if="item.wupinpinpai">{{item.wupinpinpai}}</div>
                                    </div>
                                    <div style="font-size: 11px;color: red;line-height: 1;margin-top: 8px;" v-if="item.actived===false">已停用</div>
                                    <div style="font-size: 11px;color: red;line-height: 1;margin-top: 8px;" v-if="item.weixiafa">未下发</div>
                                    <div style="font-size: 11px;color: red;line-height: 1;margin-top: 8px;" v-if="item.error">{{item.error}}</div>
                                </div>
                                <div v-else-if="c.type=='selection'">
                                    <div v-if="c.editable">
                                        <Select v-if="c.version==2||c.batchset" :value="item[c.keyStr || (c.key+'Str')]" :name="item[c.keyStr || (c.key+'Str')]+index" @on-change="dataChanged(item,c,$event,index)" :style="'width: '+(c.width - 10)+'px;'">
                                            <Option v-for="(s,si) in c.selections(item)" :key="si" :value="c.selectionvalue?c.selectionvalue(s):s[c.selectionKey]">
                                                {{c.selectionrender?c.selectionrender(item,s):s[c.selectionKey]}}
                                            </Option>
                                        </Select>
                                        <select v-else class="wupin-select" v-model="item[c.keyStr || (c.key+'Str')]" :name="item[c.keyStr || (c.key+'Str')]+index" @change="dataChanged(item,c,item[c.keyStr || (c.key+'Str')],index)" :style="'width: '+(c.width - 20)+'px;'">
                                            <option class="wupin-option" v-for="(s,si) in c.selections(item)" :key="si" :value="c.selectionvalue?c.selectionvalue(s):s[c.selectionKey]">
                                                {{c.selectionrender?c.selectionrender(item,s):s[c.selectionKey]}}</span>
                                            </option>
                                        </select>
                                    </div>
                                    <div v-else>{{item[c.keyStr || (c.key+'Str')]}}</div>
                                </div>
                                <div v-else-if="c.type=='danjia'">
                                    <div v-if="c.permission && !session.permission[c.permission]">--</div>
                                    <div v-else>
                                        <custom-input :value="item[c.key]" :fix="c.fixAppend ? c.fixAppend(item) : 6" :min="c.min" :max="c.max" :required="c.required" @input="getInput($event, item, c, index)" :width="columns[i].width - 10" v-if="c.editable" :unit="c.append? c.append(item) : ''"></custom-input>
                                        <div v-else-if="c.calculate">{{c.calculate(item) | AmountDecimal(c.fixAppend ? c.fixAppend(item) : 6)}}</div>
                                        <div v-else>{{item[c.key] | AmountDecimal(c.fixAppend ? c.fixAppend(item) : 6)}}</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type=='jine'">
                                    <div v-if="c.permission && !session.permission[c.permission]">--</div>
                                    <div v-else>
                                        <custom-input :value="item[c.key]" :fix="2" :min="c.min" :max="c.max" :required="c.required" @input="getInput($event, item, c, index)" :width="columns[i].width - 10" v-if="c.editable" :unit="c.append? c.append(item) : ''"></custom-input>
                                        <div v-else-if="c.calculate">{{c.calculate(item) | AmountDecimal(2)}}</div>
                                        <div v-else>{{item[c.key] | AmountDecimal(2)}}</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type=='shuilv'">
                                    <div v-if="c.permission && !session.permission[c.permission]">--</div>
                                    <div v-else>
                                        <custom-input :value="item[c.key]" :fix="4" :min="c.min" :max="c.max" :required="c.required" @input="getInput($event, item, c, index)" :width="columns[i].width - 10" v-if="c.editable" :unit="c.append? c.append(item) : ''"></custom-input>
                                        <div v-else-if="c.calculate">{{c.calculate(item) | AmountDecimal(4)}}</div>
                                        <div v-else>{{item[c.key] | AmountDecimal(4)}}</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type=='shuliang'">
                                    <div v-if="c.permission && !session.permission[c.permission]">--</div>
                                    <div v-else>
                                        <custom-input :value="item[c.key]" :fix="6" :min="c.min" :max="c.max" @input="getInput($event, item, c, index)" :width="columns[i].width - 10" v-if="c.editable" :unit="c.append? c.append(item) : ''"></custom-input>
                                        <div v-else-if="c.calculate">{{c.calculate(item) | AmountDecimal(6)}}</div>
                                        <div v-else>{{item[c.key] | AmountDecimal(6)}}</div>
                                    </div>
                                </div>
                                <div v-else-if="c.type === 'beizhu'">
                                    <div v-if="c.editable">
                                        <Input v-model="item[c.key]" placeholder="请输入" />
                                    </div>
                                    <div v-else>{{item[c.key]}}</div>
                                </div>
                                <div v-else>
                                    <div v-if="c.html">
                                        <div v-html="c.html(item,index)"></div>
                                    </div>
                                    <div v-else>{{(item[c.key] && c.subKey) ? item[c.key][c.subKey] : item[c.key]}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="height:20px"></div>
                <div v-if="(!newItems.length || option.alwaysShowAddButton) && editable" style="position: relative">
                    <div class="center" style="position:absolute;left: calc(50% - 50px);height: 40px;">
                        <Button type="default" style="width:100px" @click="addItem">{{option.buttonLabel||'新增'}}
                            <Icon type="ios-add"></Icon>
                        </Button>
                    </div>
                    <div style="height:40px"></div>
                </div>
            </div>
        </div>
        <div style="margin-top: 20px;display: flex;align-items: center;" v-if="!editable && !onepagemode && (total > page.size || page.size>10)">
            <!-- <Input search style="width: 200px;margin-right: 20px;" size="small" placeholder="搜索" v-model="query.keywords" @on-enter="keywordsChanged"></Input> -->
            <!-- <Input search style="width: 200px;margin-right: 20px;" size="small" placeholder="类别搜索" v-model="query.leibieStr" @on-enter="leibieChanged"></Input> -->
            <Page placement="top" :page-size-opts="[10,20,50,100,200]" :total="total" :current="page.current" :page-size="page.size" @on-change="pageChanged" @on-page-size-change="pageSizeChanged" show-sizer show-total size="small"></Page>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            columns: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
            option: {
                type: Object,
                default: () => { }
            },
            queryForm: {
                type: Object,
                default: () => { }
            },
            minHeight: {
                type: Number,
            },
            maxHeight: {
                type: String
            },
            quickedit: false, //是否支持快捷加减按钮,
            checkable: false, //是否支持选中
            guanxiajigou: false,//当内容是机构且需要按照管辖范围过滤时，设置为true
            scollBarThick: {
                type: Boolean,
                default: true
            },
            autoHideScrollBar: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                onepagemode: false,
                allitemChecked: false,
                batchitem: { _batchitem: true },
                loading: false,
                total: 0,
                page: {
                    size: 10,
                    current: 1
                },
                query: {
                    keywords: "",
                    leibieStr: "",
                },
                newItems: [],
                usedKeywords: '',
                // items: [],
                selections: [],
                session: this.$store.session,
            }
        },
        watch: {
            'items': function (v) {
                if (this.guanxiajigou && this.$store.session.zhanghao.guanxiajigous) {
                    for (let item of v) {
                        if (this.$store.session.zhanghao.guanxiajigous.some(o => { return o._id == item._id })) {
                            delete item._readonly
                        } else {
                            item._readonly = true
                        }
                    }
                }
                this.newItems = v
            },
            queryForm: {
                handler(v) {
                    this.query.keywords = v.keywords
                    this.query.leibieStr = v.leibieStr
                    this.page.current = 1
                    this.loadData()
                },
                // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
                // immediate: true,
                deep: true
            }
        },
        computed: {
            customTableClass() {
                let cls = 'scroll-none'
                // 滚动条加厚
                if (this.scollBarThick) {
                    cls += ' scroll-none-thick'
                }
                // 没有数据的时候隐藏滚动条
                if (this.autoHideScrollBar && this.newItems.length === 0) {
                    cls += ' scroll-none-hide'
                }
                return cls
            },
            customTableStyle() {
                let str = `overflow: scroll;overflow-y: hidden; display: grid; width: 100%; padding-bottom: 20px;min-height: ${this.minHeight || 100}px;`
                if (this.maxHeight) {
                    str += `;max-height: ${this.maxHeight};overflow-y: scroll;`
                }
                return str
            }
        },
        mounted() {
            this.newItems = this.items
        },
        methods: {
            getInput(value, item, c, index) {
                if (index == 'batch') {
                    for (let i = 0; i < this.newItems.length; i++) {
                        let checkedItem = this.newItems[i]
                        if (checkedItem._checked) {
                            this.getInput(value, checkedItem, c, i)
                        }
                    }
                    this.$set(item, c.key, value)
                    return
                }
                let key = c.keyStr || c.key
                this.$set(item, c.key, value)
                if (c.oninput) c.oninput(value, key, index)
                if (c.onchange) c.onchange(value, key, index)
            },
            dataChanged(item, c, valueStr, index) {
                if (item._batchitem) {
                    if (valueStr !== undefined) {
                        for (let i = 0; i < this.newItems.length; i++) {
                            let checkedItem = this.newItems[i]
                            if (checkedItem._checked) {
                                this.dataChanged(checkedItem, c, valueStr, i)
                            }
                        }
                    }
                    this.$set(item, c.keyStr || (c.key + 'Str'), valueStr)
                    return
                }
                let key
                if (c.type == "selection") {
                    key = c.keyStr || (c.key + 'Str')
                } else {
                    key = c.keyStr || c.key
                }
                let data = {}
                data[c.selectionKey] = valueStr
                item[c.key] = c.selections(item).findOne(data)
                if (c.onchange) c.onchange(valueStr, key, index, item)
            },
            showSelections() {
                this.query.selections = this.selections.map(item => { return { _id: item._id } })
                this.page.current = 1
                this.loadData()
            },
            keywordsChanged() {
                this.usedKeywords = this.query.keywords
                this.page.current = 1
                this.loadData()
            },
            leibieChanged() {
                // this.usedKeywords = this.query.leibieStr
                this.page.current = 1
                this.loadData()
            },
            sortChanged() {
                this.page.current = 1
                this.loadData()
            },
            async loadData() {
                if (this.option.dataurl) {
                    this.loading = true
                    let res = await this.$api.post(this.option.dataurl, {
                        query: this.query,
                        fields: this.option.fields,
                        page: this.page
                    })
                    this.loading = false
                    this.newItems = res.data.items
                    this.total = res.data.total
                } else if (this.option.items) {
                    this.newItems = this.option.items
                    this.total = this.option.items.length
                    this.page.size = this.total
                    this.onepagemode = true
                }
                if (this.option && this.option.onload) {
                    this.option.onload(this.newItems)
                }
            },
            pageSizeChanged(value) {
                this.page.size = value
                // sessionStorage.pagesize = value
                if (this.page.current == 1) this.loadData()
            },
            pageChanged(value) {
                this.page.current = value
                this.loadData()
            },
            addItem(item, index) {
                this.$emit('addItem', { item, index })
                this.checkStateChanged()
            },
            removeItem(item, index) {
                this.items.splice(index, 1)
                this.$emit('removeItem', { item, index })
                this.checkStateChanged()
            },
            checkChanged() {
                this.checkStateChanged()
            },
            checkStateChanged() {
                this.allitemChecked = this.newItems.every(item => item._checked)
                if (this.newItems.length == 0) this.allitemChecked = false
                this.batchitem = { _batchitem: true }
            },
            checkAllChanged() {
                this.allitemChecked = !this.allitemChecked
                if (this.allitemChecked) {
                    for (let item of this.newItems) {
                        item._checked = true
                    }
                } else {
                    for (let item of this.newItems) {
                        item._checked = false
                    }
                }
                this.checkStateChanged()
            }
        },
        created() {
            // this.$set(this.page, 'size', Number(sessionStorage.pagesize || 10))
            this.editable = this.option.editable
            if (this.option.dataurl) {
                if (this.option.datasize) {
                    this.page.size = this.option.datasize
                } else {
                    this.page.size = 10
                }
                if (this.option.dataquery) {
                    for (let key of Object.keys(this.option.dataquery)) {
                        this.query[key] = this.option.dataquery[key]
                    }
                }
                this.loadData()
            } else if (this.option.items) {
                this.loadData()
            }
        },
    }
</script>

<style scoped>
    .flex {
        display: flex;
        align-items: center;
    }

    .wupin-select {
        color: #515a6e;
        font-size: 14px;
        line-height: normal;
        display: block;
        box-sizing: border-box;
        outline: none;
        user-select: none;
        cursor: pointer;
        position: relative;
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid #dcdee2;
        transition: all .2s ease-in-out;
        height: 32px;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/CustomTable.vue?c8756654